export default function redirect(url) {
  const isClient = typeof window !== 'undefined';
  if (!isClient) {
    return;
  }

  window.location.assign(url);
}
